module.exports = __webpack_public_path__ + "img/app3.3d818352.png";